import { editEtfStrategy } from "./thunk";

export const setCollapseFilterReducer = (state, action) => {
  state.isFilterVisible = action.payload;
};

export const setSelectedPortfolioReducer = (state, action) => {
  state.selectedPortfolio = action.payload;
};

export const editEtfStrategyCases = (builder) => {
  builder.addCase(editEtfStrategy.pending, (state) => {
    state.errorMessage = "";
    state.isSaving = true;
  });
  builder.addCase(editEtfStrategy.fulfilled, (state) => {
    state.errorMessage = "";
    state.isSaving = false;
    state.isUnsaved = false;
  });
  builder.addCase(editEtfStrategy.rejected, (state, action) => {
    state.errorMessage = action.payload.error;
    state.isSaving = false;
  });
};

export const setSelectedFilterReducer = (state, action) => {
  state.selectedFilter = action.payload;
};

export const setSelectedAssetsReducer = (state, action) => {
  state.selectedAssets = action.payload;
};

export const addSelectedAssetsReducer = (state, action) => {
  state.selectedAssets.push(action.payload);
};

export const removeSelectedAssetsReducer = (state, action) => {
  state.selectedAssets = state.selectedAssets.filter(
    (asset) => asset.symbol !== action.payload
  );
};

export const updateSelectedAssetsReducer = (state, action) => {
  const assetIndex = state.selectedAssets.findIndex(
    (asset) => asset.symbol === action.payload.symbol
  );
  state.selectedAssets[assetIndex] = {
    ...state.selectedAssets[assetIndex],
    ...action.payload,
  };
};

export const setIsUnsavedReducer = (state, action) => {
  state.isUnsaved = action.payload;
};

export const setShowBacktestTabReducer = (state, action) => {
  state.showBacktestTab = action.payload;
};

export const setDisabledSaveReducer = (state, action) => {
  state.disabledSave = action.payload;
};

export const resetEtfToDefaultReducer = (state) => {
  state.errorMessage = "";
  state.isSaving = false;
  state.selectedPortfolio = {
    allocations: {},
    name: "",
    frequency: 30,
    period: "days",
  };
  state.selectedFilter = {};
  state.selectedAssets = [];
  state.isUnsaved = false;
  state.showBacktestTab = false;
  state.disabledSave = false;
  state.isFilterVisible = false;
};
